import React from "react";
import {
    UserWorkExperience,
    RangeInputSelectedValue,
} from "../../../../containers/RegistrationLoginPage/types";
import RangeInput from "../../../RangeInput";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
    numberValidation,
    regNumberValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface WorkExperienceInterface {
    configuration: UserWorkExperience;
}

const WorkExperience: React.FC<WorkExperienceInterface> = ({
    configuration,
}: WorkExperienceInterface) => {
    const {editable, values, selectedValue, fieldName} = configuration;

    return (
        <Field<RangeInputSelectedValue>
            name={fieldName}
            validate={composeValidators(
                regRequiredValidate("Please move slider to select work experience"),
                regNumberValidate("Invalid work experience"),
                numberValidation(values?.min, values?.max, values?.step),
            )}
            initialValue={selectedValue}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <RangeInput
                        heading="Work Experience"
                        subheading=" (in years)"
                        editable={editable}
                        values={values}
                        isFocused={props.meta.active}
                        isTouched={props.meta.touched}
                        isError={errorHandler(props?.meta)}
                        initialValue={props.input.value}
                        inputRFF={props.input}
                    />
                );
            }}
        </Field>
    );
};

export default WorkExperience;
